import Nullstack from 'nullstack';
export default function IconRelationManyToMany({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-relation-many-to-many",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M15 14v-4l3 4v-4"
  }), "   ", Nullstack.element("path", {
    d: "M6 14v-4l3 4v-4"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "10.5",
    x2: "12",
    y2: "10.51"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "13.5",
    x2: "12",
    y2: "13.51"
  }), " ");
}